export default "__VITE_ASSET__Banpo6g___"